export enum TelehealthIntakeTheme {
  HRT = "HRT",
  Default = "Default",
}
